import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedProduct: "",
  selectedComponent: "",
  selectedTestCase: "",
  selectedTestCaseName: "",
  selectedTestSuite: "",
  testCaseResults: [],
  allTestSteps: [], // Store all test steps from TestStudio
  executedStepIds: [], // Store executed step IDs
  isDebugMode: false,
  debugStepNumber: null,
  debugMode: "run",
};

const executionReportSlice = createSlice({
  name: "executionReport",
  initialState,
  reducers: {
    setSelectedProduct: (state, action) => {
      state.selectedProduct = action.payload;
    },
    setSelectedComponent: (state, action) => {
      state.selectedComponent = action.payload;
    },
    setSelectedTestCase: (state, action) => {
      state.selectedTestCase = action.payload;
    },
    setSelectedTestCaseName: (state, action) => {
      state.selectedTestCaseName = action.payload;
    },
    setSelectedTestSuite: (state, action) => {
      state.selectedTestSuite = action.payload;
    },
    setTestCaseResults: (state, action) => {
      state.testCaseResults = action.payload;
    },
    setAllTestSteps: (state, action) => {
      state.allTestSteps = action.payload;
    },
    addExecutedStep: (state, action) => {
      if (!state.executedStepIds.includes(action.payload)) {
        state.executedStepIds.push(action.payload);
      }
    },
    clearExecutedSteps: (state) => {
      state.executedStepIds = [];
    },
    setIsDebugMode: (state, action) => {
      state.isDebugMode = action.payload;
    },
    setDebugStepNumber: (state, action) => {
      state.debugStepNumber = action.payload;
    },
    setDebugMode: (state, action) => {
      state.debugMode = action.payload;
    },
    resetExecutionReport: (state) => {
      return initialState;
    },
  },
});

export const {
  setSelectedProduct,
  setSelectedComponent,
  setSelectedTestCase,
  setSelectedTestCaseName,
  setSelectedTestSuite,
  setTestCaseResults,
  setAllTestSteps,
  addExecutedStep,
  clearExecutedSteps,
  setIsDebugMode,
  setDebugStepNumber,
  setDebugMode,
  resetExecutionReport,
} = executionReportSlice.actions;

export default executionReportSlice.reducer;
